export default {
  "name": "Boundary",
  "slug": "boundary",
  "path": "/boundary",
  "componentName" : "Boundary",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}